import React from 'react';
import classNames from 'classnames';
import styles from './PopupGenOnePremiumAIResponse.module.scss';
import Popup, { Props as PopupProps } from '../Popup';
import PremiumBenefits, {
  TitleVersion,
} from '../PremiumBenefits/PremiumBenefits';
import Icon, { IconGlyph } from '../../Icon';
import { renderTextWithIndexedTags } from '../../../utilities/helpers/phrases';
import { Phrases } from '../../../utilities/constants/phrases';
import Title from '../../TitleWithGradient/TitleWithGradient';
import LinearLoader, {
  Props as LinearLoaderProps,
} from '../../LinearLoader/LinearLoader';
import Rating from '../Rating/Rating';
import { EditorPopupId } from '../../../utilities/constants/popup-type';

const POPUP_ID = EditorPopupId.GEN_ONE_PREMIUM_AI_RESPONSE;
const GENERATION_DURATION = 10000;

interface Props
  extends Pick<PopupProps, 'isOpen' | 'onClose'>,
    Pick<LinearLoaderProps, 'isLoading'> {}

const PopupGenOnePremiumAIResponse: React.FC<Props> = ({
  isOpen,
  isLoading = false,
  onClose,
}) => (
  <Popup
    isOpen={isOpen}
    id={POPUP_ID}
    size='lg'
    role='alertdialog'
    dialogClassName={styles.popupGenOnePremiumAIResponse}>
    <div
      className={classNames(
        styles.animatedElement,
        'd-flex flex-col flex-ai-c gap-xxxs mb-md'
      )}>
      <Icon glyph={IconGlyph.AI_ICON} />
      <Title
        title={renderTextWithIndexedTags(
          Phrases.POPUP_GEN_ONE_PREMIUM_AI_RESPONSE_TITLE,
          [<span key='span-0' />]
        )}
        className='text-xl fw-bold ta-center mt-xs'
      />
      <p className='text-sm ta-center c-main-light'>
        {renderTextWithIndexedTags(
          Phrases.POPUP_GEN_ONE_PREMIUM_AI_RESPONSE_SUBTITLE,
          [
            <span
              key='span-0'
              className='fw-bold c-main'
            />,
          ]
        )}
      </p>
      <LinearLoader
        isLoading={isLoading}
        onSuccess={onClose}
        duration={GENERATION_DURATION}
        color='gradient'
        className={classNames(styles.linearLoader, 'mt-md')}
      />
    </div>
    <PremiumBenefits
      titleVersion={TitleVersion.V1}
      className='mb-xxxl'
      animatedVisible
    />
    <Rating />
  </Popup>
);

export default PopupGenOnePremiumAIResponse;
